import React from "react";
import { formatDate, FormatValueDecimal } from '../../utils/Validate';
import { NotFound } from '../common/NotFound';
import Avatar from "../common/Avatar";
import PaginationComponent from '../common/PaginationComponent';
import SkeletonQuotationListing from '../common/skeletonQuotationListing';

const FactoryOrderGrid = (props) => {
        const { menuRights, handleDelete, handleView, handleEdit, assignedEngineerList, loading, orderList, filterData, setPageNumber, setPageSize, pageSize, distributorData, projectData, countryData, customerData, currencyData, orderDataList } = props;

        const safeNumber = (value) => Number(value ?? 0) || 0;
const getOrderItems = (record) => {
    console.log('record',record)
    const candidateLists = [
        record?.products,
        record?.productItems,
        record?.items,
    ];

    return candidateLists.find((list) => Array.isArray(list)) || [];
};

        const getItemKey = (item) =>
            item?.customerOrderProductItemId ??
            item?.quoteProductItemId ??
            item?.orderProductItemId ??
            item?.id ??
            item?.quoteProductId ??
            "";

        const getLpoQuantity = (item) =>
            safeNumber(
                item?.lpoQuantity ??
                item?.customerOrderedQuantity ??
                item?.orderedQuantity ??
                item?.quantity ??
                0
            );

        const getReleasedQuantity = (item) =>
            safeNumber(
                item?.factoryReleasedQuantity ??
                item?.releasedQuantity ??
                item?.quantity ??
                0
            );


        const getReleasedOrderValue = (record) => {
            return safeNumber(record?.factoryReleaseValue ?? 0);
        };

        const resolvedOrders = orderList?.payload || [];
        const relatedOrderSource = Array.isArray(orderDataList?.payload)
            ? orderDataList.payload
            : Array.isArray(orderDataList)
                ? orderDataList
                : [];

       const summaryStats = resolvedOrders.reduce(
    (accumulator, item) => {
        const relatedOrder = relatedOrderSource.find(
            (items) =>
                items?.id === item?.customerOrderId ||
                items?.id === item?.orderId
        );

        const projectId =
            relatedOrder?.projectId ||
            item?.projectId ||
            item?.project?.id;

       const orderValue = getReleasedOrderValue(item);
accumulator.totalOrderValue += orderValue;

        if (item?.isLockedForEdit === true) {
            accumulator.releasedOrders += 1;
        }

        if (item?.isLockedForEdit === false) {
            accumulator.pendingOrders += 1;
        }

        if (projectId != null) {
            accumulator.projectIds.add(String(projectId));
        } else if (item?.projectName) {
            accumulator.projectNames.add(String(item.projectName));
        }

        return accumulator;
    },
    {
        totalOrders: orderList?.totalRecords ?? resolvedOrders.length,
        totalOrderValue: 0,
        releasedOrders: 0,
        pendingOrders: 0,
        projectIds: new Set(),
        projectNames: new Set(),
    }
);

 return (
 <>
        {orderList?.payload?.length > 0 ?
            <div className="row order-table-row row-height mb-1">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="quote-general-stats-strip" aria-label="Quotation summary"> 
                        <div className="quote-general-stat">
                            <span>Total Factory Orders</span>
                            <strong>{summaryStats.totalOrders}</strong>
                        </div>
                        <div className="quote-general-stat">
                            <span>Total Factory Order Value</span>
                            <strong>{FormatValueDecimal(summaryStats.totalOrderValue)}</strong>
                        </div>
                        <div className="quote-general-stat">
                            <span>Released Orders</span>
                            <strong>{summaryStats.releasedOrders}</strong>
                        </div>
                        <div className="quote-general-stat">
                            <span>Pending Orders</span>
                            <strong>{summaryStats.pendingOrders}</strong>
                        </div>
                       
                    </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="card mt-0 order-list-card">
                        <div className="card-body">
                            <div className="table-responsive order-table-responsive">
                                <table className="table table-borderless table-list order-table-list">
                                    <thead>
                                        <tr>
                                            <th><div>PROJECT</div></th>
                                            <th><div>FACTORY RELEASE REF</div></th>
                                            <th><div>SCHEDULE DELIVERY DATE</div></th>
                                            <th><div>CUSTOMER</div></th>
                                            <th style={{width: "3%"}}><div>COUNTRY</div></th>
                                            <th style={{width: "8%"}} className="text-right"><div>ORDER VALUE</div></th>
                                            <th><div>CURRENCY</div></th>
                                            <th><div>ACTIONS</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderList?.payload.map((item, index) => {
                                            const orderLists = relatedOrderSource?.find(items=>items?.id === item?.customerOrderId || items?.id === item?.orderId)
                                            const projectDetails = projectData?.find(project => project.id === orderLists?.projectId);
                                            const distributorDetails = distributorData?.find(distributor => distributor.id === orderLists?.distributorId);
                                            const countryDetails = countryData?.find(country => country.id === orderLists?.countryId);
                                            const customerDetails = customerData?.find(customer => customer.id === orderLists?.customerId);
                                            const currencyDetails = currencyData?.find(currency => currency.id === orderLists?.currencyId);
                                            const assignedEngineerDetails = assignedEngineerList?.find(engineer => engineer.identityId === orderLists?.salesEngineerId);
                                            const handleProjectEdit = menuRights?.canEdit === true
                                                ? () => handleEdit(item)
                                                : undefined;
                                            return (
                                                <tr key={item?.id || index}>
                                                    <td
                                                        onClick={handleProjectEdit}
                                                        className={menuRights?.canEdit === true ? "clickable-cell" : ""}
                                                    >
                                                        <div className="project-cell">
                                                            <Avatar preName={projectDetails?.projectName || item?.projectName} />
                                                            <h5 title={projectDetails?.projectName || item?.projectName}>{projectDetails?.projectName || item?.projectName || "-"}</h5>
                                                        </div>
                                                    </td>
                                                    <td
                                                        onClick={handleProjectEdit}
                                                        className={menuRights?.canEdit === true ? "clickable-cell" : ""}
                                                    >
                                                        <div className="project-cell">
                                                            <h5 title={item?.factoryReleaseReference}>{item?.factoryReleaseReference || "-"}</h5>
                                                        </div>
                                                    </td>
                                                    <td><h5 title={item?.scheduledDeliveryDate}>{formatDate(item?.scheduledDeliveryDate) || "-"}</h5></td>
                                                    <td><h5 title={customerDetails?.customerName || item?.customerName}>{customerDetails?.customerName || item?.customerName || "-"}</h5></td>
                                                    <td><h5 title={countryDetails?.name || item?.countryName}>{countryDetails?.name || item?.countryName || "-"}</h5></td>
                                                    <td className="text-right"><h5>{item?.factoryReleaseValue ? FormatValueDecimal(item?.factoryReleaseValue) : "-"}</h5></td>
                                                    <td><h5 title={currencyDetails?.shortCode || item?.currencyName}>{currencyDetails?.shortCode || item?.currencyName || "-"}</h5></td>
                                                   
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-baseline">
                                                            <div class="dropdown dropleft text-center action-menu">
                                                                <i
                                                                    class="fas fa-ellipsis-v"
                                                                    id="dropdownMenuButton"
                                                                    data-toggle="dropdown"
                                                                    aria-haspopup="false"
                                                                    aria-expanded="false"
                                                                ></i>
                                                                <div
                                                                    class="dropdown-menu p-0"
                                                                    aria-labelledby="dropdownMenuButton"
                                                                >
                                                                    <ul>
                                                                        {menuRights?.canEdit === true && <li onClick={() => handleEdit(item)}>
                                                                            <span>
                                                                                <i class="far fa-edit"></i> Edit
                                                                            </span>
                                                                        </li>}
                                                                        {menuRights?.canDelete === true && <li onClick={() => handleDelete(item)}>
                                                                            <span>
                                                                                <i class="far fa-trash-alt mr-1"></i> Delete
                                                                            </span>
                                                                        </li>}
                                                                        {menuRights?.canView === true &&
                                                                            <li>
                                                                                <span title="View" onClick={() => handleView(item, projectDetails, distributorDetails, countryDetails, customerDetails, currencyDetails, assignedEngineerDetails)}>
                                                                                    <i className="fa fa-eye"></i> View
                                                                                </span>
                                                                            </li>}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : loading === true ? <>
                <SkeletonQuotationListing rows={12} />
            </> : <NotFound />}

        {orderList?.totalRecords > 0 && (
            <PaginationComponent
                moduleName="Order"
                count={pageSize}
                setCount={setPageSize}
                pageSize={filterData?.PageSize}
                currentPage={filterData?.PageNumber}
                filteredResults={orderList}
                setCurrentPage={setPageNumber} />)}

    </>
    )
}

export default FactoryOrderGrid
